import { Stack, Typography } from '@mui/material'
import styled from 'styled-components'

export const LCDialogContent = styled(Stack)`
  min-width: 400px;
  height: 200px;
  padding: 24px 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

export const LCDialogTitle = styled(Typography)`
  font-size: 34px !important;
  font-weight: 700 !important;
  text-align: center;
  line-height: 1.2 !important;
  color: #333333 !important;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0 auto;
  display: block;

  @media (max-width: 600px) {
    font-size: 18px !important;
    line-height: 1.2 !important;
  }
`

export const LCDialogText = styled(Typography)`
  font-size: 34px !important;
  text-align: center;
  font-weight: 400 !important;
  margin: 0 !important;
  padding: 0 !important;
  margin-top: 16px !important;
  line-height: 22px !important;

  @media (max-width: 600px) {
    font-size: 14px !important;
    line-height: 20px !important;
  }
`

export const LCDialogLink = styled.span`
  font-size: 30px;
  font-weight: 400;
  font-style: italic;
  cursor: pointer;
  text-align: center;
  line-height: 22px !important;
  display: inline-block;

  @media (max-width: 600px) {
    font-size: 14px !important;
    line-height: 20px !important;
  }
`

export const CloseIcon = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  z-index: 1;

  @media (max-width: 600px) {
    width: 18px;
    height: 18px;
    top: 10px;
    right: 10px;
  }
`
